import { Users, Award } from 'lucide-react';

const foundingMembers = [
  {
    name: 'Prof. Dr. Bakhtiyar Najafov',
    photo: '/founders/bahtiyar.jpeg',
    titles: [
      'President, Union of International Education and Higher Education Centers (UIEHEC)',
      'Vice-Rector, International Science and Technology University (ISTU), Poland',
      'CEO, Varan Colleges',
      'CEO, Education Support Services (EDUSS)'
    ],
    isPresident: true
  },
  {
    name: 'Prof. Dr. Erdal Dursun',
    photo: '/founders/erdal.jpeg',
    titles: [
      'Rector, International Science and Technology University (ISTU)',
      'Rector, AI Vision Institute and University',
      'Founding President, Institute of International Students (IOIS)',
      'President, Global Power Union (GPU)'
    ]
  },
  {
    name: 'Prof. Dr. Imran Akperov',
    photo: '/founders/imran_akperov.jpg',
    titles: [
      'Rector, Southern University',
      'President, Business Eurasia Education Alliance'
    ]
  },
  {
    name: 'Prof. Dr. Dmitriy Škyev',
    photo: '/founders/dimitri.jpeg',
    titles: [
      'Founding Director, UNIGAME – The United Institute of Gaming and Gamification'
    ]
  },
  {
    name: 'Dr. Mehmet Macar',
    photo: '/founders/mehmet-macar.jpg',
    titles: [
      'Owner, Wall Street English'
    ]
  },
  {
    name: 'Ahmed Darwish',
    photo: '/founders/ahmed-darwish.jpeg',
    titles: [
      'Founder, Study in Türkiye'
    ]
  },
  {
    name: 'Ramal Shamshadli',
    photo: '/founders/ramal-shamshadli.jpeg',
    titles: [
      'CEO, International Education Center'
    ]
  },
  {
    name: 'Farid Hasanzada',
    photo: '/founders/ferid.jpg',
    titles: [
      'CEO, Marmara Group Education Center'
    ]
  },
  {
    name: 'Miryusif Javadzade',
    photo: '/founders/miryusif.jpeg',
    titles: [
      'CEO, EDDE Global'
    ]
  },
  {
    name: 'Mikayil Mirzazada',
    photo: '/founders/mikayiil.jpg',
    titles: [
      'Founder, Ege Group Study Abroad Center'
    ]
  },
  {
    name: 'Rashad Abbasov',
    photo: '/founders/rashad-abbasov.jpeg',
    titles: [
      'CEO, Educo Azerbaijan'
    ]
  },
  {
    name: 'Huseyin Vagıfzada',
    photo: '/founders/huseyin-vagifzada.jpeg',
    titles: [
      'CEO, Brain Academy'
    ]
  },
];

export default function FoundingMembersPage() {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-[#0E285B] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <div className="flex items-center justify-center gap-2 mb-6">
              <Users className="h-6 w-6 text-[#F5A623]" />
              <span className="text-[#F5A623] font-medium uppercase tracking-wider text-sm">
                Our Foundation
              </span>
            </div>
            <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl font-bold text-white leading-tight mb-6">
              Founding Members
            </h1>
            <p className="text-slate-300 text-lg">
              UIEHEC is guided by a distinguished community of founding members who shape its 
              international vision and strategic direction.
            </p>
          </div>
        </div>
      </section>

      {/* Founding Members Grid */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {foundingMembers.map((member, index) => (
              <div 
                key={index}
                className={`bg-white p-8 rounded-sm shadow-sm hover:shadow-lg transition-shadow ${
                  member.isPresident ? 'border-t-4 border-[#F5A623] md:col-span-2 lg:col-span-1' : 'border-t-4 border-[#0E285B]'
                }`}
                data-testid={`founding-member-${index}`}
              >
                <div className="flex flex-col items-center text-center mb-6">
                  <div className="relative mb-4 overflow-hidden rounded-full border-4 border-slate-100 shadow-lg" style={{ width: '176px', height: '176px' }}>
                    <img 
                      src={member.photo} 
                      alt={member.name}
                      className="w-full h-full object-cover"
                      style={{ 
                        objectPosition: member.name === 'Dr. Mehmet Macar' ? 'center center' : 'center 20%',
                        transform: member.name === 'Dr. Mehmet Macar' ? 'scale(1.4)' : 'scale(1)'
                      }}
                    />
                  </div>
                  <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#0E285B] mt-2">
                    {member.name}
                  </h3>
                  {member.isPresident && (
                    <span className="mt-1 px-3 py-1 bg-[#F5A623] text-[#0E285B] text-xs font-bold rounded">
                      PRESIDENT
                    </span>
                  )}
                </div>
                <ul className="space-y-2 text-sm text-slate-600">
                  {member.titles.map((title, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="text-[#F5A623] mt-1 flex-shrink-0">•</span>
                      <span>{title}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Award className="h-12 w-12 text-[#F5A623] mx-auto mb-4" />
          <p className="text-slate-600">
            Founding Members are signatories of the UIEHEC Founding Memorandum of Understanding (MoU), 
            establishing the foundation for international cooperation in higher education.
          </p>
        </div>
      </section>
    </div>
  );
}
